import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { useThemeColors } from '@/hooks/useThemeColors'
import { InvoiceForm } from '@/components/forms/InvoiceForm'
import {
  invoiceIdFromSearchParams,
  shippingLineIdFromSearchParams,
  shippingLineNameFromSearchParams,
} from '@/lib/navigation/financialStatementsSearchParams'

export default function EditInvoicePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const params = useParams<{ shippingLineId: string; id: string }>()
  const paramsShippingLineId = params.shippingLineId
  const invoiceId = params.id ? parseInt(params.id, 10) : undefined

  const shippingLineName = shippingLineNameFromSearchParams(searchParams)
  const finalShippingLineId =
    paramsShippingLineId ?? shippingLineIdFromSearchParams(searchParams)
  const finalInvoiceId = invoiceId ?? invoiceIdFromSearchParams(searchParams)

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit Invoice
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update Invoice details
            </Text>
          </CardHeader>
          <CardBody>
            <InvoiceForm
              invoiceId={finalInvoiceId}
              registeredName={shippingLineName}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
